<ul class="messages-list" #messageBox (load)="scrollDown()">
  <li *ngFor="let message of messages" class="messages-list-elem text-{{message.side}}">
    <div class="pull-{{message.side}} message">
      <span *ngIf="message.side == 'right'" class="text-{{message.side}} message-title"> <span class="date">{{message.updatedAt}} </span><span
        class="author">{{translate.instant(message.author)}}</span> </span>
      <span *ngIf="message.side == 'left'" class="text-{{message.side}} message-title"> <span class="author">{{translate.instant(message.author)}} </span><span
        class="date">{{message.updatedAt}}</span></span>
      <p class="message-content">
        <span [innerHTML]="message.content"></span>
      </p>
    </div>
  </li>
  <li class="messages-list-elem placeholder" *ngIf="messages.length == 0">
    {{translate.instant('DATA.NO_MESSAGE')}}
  </li>
</ul>
<div class="new-message">
  <div class="message-display-flex">
    <textarea rows="3" [(ngModel)]="newMessage" class="textarea full-width"></textarea><br>
    <button mat-raised-button color="primary" (click)="sendMessage()" class="send-btn">
      {{translate.instant('CONTACT.SEND')}}
    </button>
  </div>
</div>
